import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ResourceWithLink from '../../../../../Common/ResourceWithLink/ResourceWithLink';

function BodySpecialListItemNoDataPlaceholder({
	className,
	placeholderText,
	placeholderClassName,
	onPlaceholderClickConfig
}) {
	return (
		<StyledBodySpecialListItemNoDataPlaceholder
			className={`StyledBodySpecialListItemNoDataPlaceholder ${className}`}
			placeholderClassName={placeholderClassName}
		>
			<ResourceWithLink placeholder={placeholderText} onPlaceholderClickConfig={onPlaceholderClickConfig} />
		</StyledBodySpecialListItemNoDataPlaceholder>
	);
}

BodySpecialListItemNoDataPlaceholder.propTypes = {
	placeholderText: PropTypes.string.isRequired,
	placeholderClassName: PropTypes.string,
	onPlaceholderClickConfig: PropTypes.map
};

BodySpecialListItemNoDataPlaceholder.defaultProps = {
	className: 'BodySpecialListItemNoDataPlaceholder',
	placeholderClassName: 'body-special-list-item-no-data-placeholder'
};

export default BodySpecialListItemNoDataPlaceholder;

const StyledBodySpecialListItemNoDataPlaceholder = styled.section`
	max-width: 100%;
	padding: var(--px-10) var(--px-16);
	border: var(--px-1) solid var(--neutrals-200);
	border-top: none;
	border-radius: var(--border-radius-medium);
	background-color: var(--neutrals-100);
	line-height: var(--px-20);
	.${(props) => props.placeholderClassName} {
		font-size: var(--px-16) !important;
		a,
		.createClickableTextLink {
			font-weight: bold !important;
			cursor: pointer;
			font-size: var(--px-14);
			color: var(--blue-600);
		}
	}
	a,
	.createClickableTextLink {
		font-weight: bold !important;
		cursor: pointer;
		font-size: var(--px-14);
		color: var(--blue-600);
		padding-left: 0;
		padding-right: 0;
	}
`;
